import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_CEREMONIES, 
  // GET_ADMIN_PROFILE,
  ADD_NEW_CEREMONY,
  UPDATE_CEREMONY,
  DELETE_CEREMONY
 } from "./actionTypes";
import {
  getCeremoniesSuccess,
  getCeremoniesFail,
  addCeremonySuccess,
  addCeremonyFail,
  updateCeremonySuccess,
  updateCeremonyFail,
  deleteCeremonySuccess,
  deleteCeremonyFail,
  // getCeremonyProfileSuccess,
  // getCeremonyProfileFail,
} from "./actions";

//Include Both Helper File with needed methods
import { 
  getCeremonies,
  // getCeremonyProfile,
  addNewCeremony,
  updateCeremony,
  deleteCeremony,
} from "../../helpers/backend_helper";
import { showPopup } from "../popup/actions";

function* fetchCeremonies({ payload: {is_active,offset,page_size} }) {
  try {
    const response = yield call(getCeremonies,{is_active,offset,page_size})
    yield put(getCeremoniesSuccess(response))

  } catch (error) {
    yield put(getCeremoniesFail(error))
    
      yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* onUpdateCeremony ({payload: ceremony }) {
  try {
   let response = yield call(updateCeremony, ceremony);
   if(response.file_src || ceremony.removeImage) ceremony.image = response.file_src
    yield put(updateCeremonySuccess(ceremony));
      yield put(showPopup({ title: response.message, success: true }));
  } catch (error) {
    yield put(updateCeremonyFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onDeleteCeremony({ payload: ceremony }) {
  
  try {
     let response = yield call(deleteCeremony, ceremony);
    yield put(deleteCeremonySuccess(ceremony));
      yield put(showPopup({ title: response.message, success: true }));
  } catch (error) {
    yield put(deleteCeremonyFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onAddNewCeremony({ payload: ceremony }) {
  try {
   let response = yield call(addNewCeremony, ceremony);
    yield put(addCeremonySuccess(response.data));
      yield put(showPopup({ title: response.message, success: true }));
  } catch (error) {
    yield put(addCeremonyFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}


// function* fetchCeremonyProfile() {
//   try {
//     const response = yield call(getCeremonyProfile);
//     yield put(getCeremonyProfileSuccess(response));
//   } catch (error) {
//     yield put(getCeremonyProfileFail(error));
//   }
// }

function* ceremonysSaga() {
  yield takeEvery(GET_CEREMONIES, fetchCeremonies);
  yield takeEvery(ADD_NEW_CEREMONY, onAddNewCeremony);
  yield takeEvery(UPDATE_CEREMONY, onUpdateCeremony);
  yield takeEvery(DELETE_CEREMONY, onDeleteCeremony);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchCeremonyProfile);
}

export default ceremonysSaga;
